import { Check, ChevronDown, X } from "lucide-react";
import { useState } from "react";

export default function Difference() {
  const withTask = [
    "Free up time to create more",
    "Huge pool of YouTube certified professionals",
    "Professional BPO facility in the Philippines",
    "Only pay for what you need",
    "50+ different roles, hire in 1 click",
    "No limitations on growth",
    "120% ROI YoY on all hires",
    "Tax deductible write-off for every hire (up to 50% saved)",
    "Meet your team in-person with annual flight ticket lotteries",
    "Easily pay your workers via EnfiniPay",
    "Cancel anytime",
  ];

  const withoutTask = [
    "Spread too thin across tasks",
    "Limited pool of workers to help",
    "Expensive overhead when hiring",
    "Training from ground up takes time",
    "Limitations on growth",
    "No longevity, contsant turnover",
    "Payroll, HR, employment laws costs & headaches"
  ];

  // ✅ only these two are needed
  const [openWith, setOpenWith] = useState(false);
  const [openWithout, setOpenWithout] = useState(false);

  return (
    <div
      id="difference"
      className="lg:py-10 mx-auto space-y-12 lg:space-y-20 4xl:max-w-[100rem]"
    >
      <div className="space-y-4 text-center px-8 lg:px-0">
        <h1 className="text-4xl md:text-5xl text-primaryLight">
          See the difference with EnfiniTask
        </h1>
        <p className="text-[#EDE9FE] max-w-md mx-auto text-sm md:text-lg">
          Why settle for limitations when you can scale smarter, faster, and
          more affordably?
        </p>
      </div>

      <div className="flex items-start">
        {/* Without EnfiniTask */}
        <div className="bg-[#161616] w-full md:px-5 py-8 text-primaryLight">
          <div
            className="flex items-center justify-center gap-2 md:gap-4 cursor-pointer"
            onClick={() => setOpenWithout(!openWithout)}
          >
            <h2 className="text-sm md:text-2xl lg:text-3xl">
              Without EnfiniTask
            </h2>
            <ChevronDown
              className={`w-4 md:w-6 h-4 md:h-6 transition-transform duration-300 ${
                openWithout ? "rotate-180" : ""
              }`}
            />
          </div>

          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden space-y-4 px-5 md:px-16 ${
              openWithout
                ? "h-[780px] xs:h-[760px] sm:h-[700px] md:h-[560px] lg:h-[540px] xl:h-[470px] opacity-100 pt-6"
                : "max-h-0 opacity-0"
            }`}
          >
            {withoutTask.map((without, index) => (
              <div key={index} className="flex gap-5">
                <div className="w-3 h-3">
                  <X />
                </div>
                <p className="text-[#EDE9FE] text-sm md:text-base">{without}</p>
              </div>
            ))}
          </div>
        </div>

        {/* With EnfiniTask */}
        <div className="bg-primary w-full md:px-5 py-8 text-white">
          <div
            className="flex items-center justify-center gap-2 md:gap-4 cursor-pointer"
            onClick={() => setOpenWith(!openWith)}
          >
            <h2 className="text-sm md:text-2xl lg:text-3xl">With EnfiniTask</h2>
            <ChevronDown
              className={`w-4 md:w-6 h-4 md:h-6 transition-transform duration-300 ${
                openWith ? "rotate-180" : ""
              }`}
            />
          </div>

          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden space-y-4 px-5 lg:px-16 ${
              openWith
                ? "h-[780px] xs:h-[760px] sm:h-[700px] md:h-[560px] lg:h-[540px] xl:h-[470px] opacity-100 pt-6"
                : "max-h-0 opacity-0"
            }`}
          >
            {withTask.map((task, index) => (
              <div key={index} className="flex gap-5">
                <div className="w-3 h-3">
                  <Check />
                </div>
                <p className="text-[#EDE9FE] text-sm md:text-base">{task}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
